import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/core';
import { GENERAL_MESSAGES } from '@app/shared';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  generalMessages = GENERAL_MESSAGES;
  isAppInMaintenanceData: boolean = false;

  constructor(
    private readonly _commonService: CommonService
  ) { 
    if (this._commonService.isAppInMaintenance) {
      this.isAppInMaintenanceData = this._commonService.isAppInMaintenance;
      console.error("404: Not Found");
    }
  }

  ngOnInit(): void {
    // no initial operations required
  }

}
